// Garante que a conta da URL existe para o usuário e que ele tem a permissão da tela.
import type { ReactNode } from 'react'
import { Link, useParams } from 'react-router-dom'
import type { MeAccount, Permission } from '@impulso/shared'
import { useSession } from '../../lib/session'
import { Empty, Loading } from '../../ui'

export default function AccountGate({ permission, children }: { permission?: Permission; children: (account: MeAccount) => ReactNode }) {
  const { accountId } = useParams()
  const { me, loading } = useSession()
  if (loading) return <Loading />
  const account = me?.accounts.find((a) => a.id === accountId)
  if (!account) return <Empty title="Conta não encontrada"><Link className="strong" to="/app">Voltar ao painel</Link></Empty>
  if (permission && !account.permissions.includes(permission)) {
    return <Empty title="Você não tem acesso a esta área">Peça ao dono ou a um administrador da conta. <Link className="strong" to="/app">Voltar ao painel</Link></Empty>
  }
  return <>{children(account)}</>
}
